import { useContext } from 'react'
import { Outlet } from 'react-router-dom'
import { PageHeader } from 'app/components/ui/page-header'
import type { TabType } from 'app/components/ui/nav-tabs'
import { PAGE_GUTTER, PageGutterContext } from 'app/components/layout/PageScroll'
import { cn } from 'app/lib/utils'

export type SettingsMappingComponentProps = {
  title: string
  tabs: TabType[]
}

export function SettingsMappingComponent({ title, tabs }: SettingsMappingComponentProps): React.ReactElement {
  const gutter = PAGE_GUTTER[useContext(PageGutterContext)]
  return (
    <div className="flex h-full flex-col">
      <div className={cn(`shrink-0 pt-8`, gutter)}>
        <PageHeader title={title} tabs={tabs} />
      </div>
      <div className="min-h-0 grow">
        <Outlet />
      </div>
    </div>
  )
}
